import { render, staticRenderFns } from "./AdQuizProfitPopup.vue?vue&type=template&id=149e63a0"
import script from "./AdQuizProfitPopup.vue?vue&type=script&lang=js"
export * from "./AdQuizProfitPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports